import { addSignCommaFormat } from 'components/features/new-report/utils/formatter';
import { formatNumber } from 'utils/formatter';
import React from 'react';

type Props = {
  estimatedPurchasePrice: number;
  dissociatePercentage: number;
  className?: string;
};

export const DeviationFromTargetBalloon = (
  props: Props
): React.ReactElement => {
  const percentageColor =
    props.dissociatePercentage > 0
      ? 'text-red-550'
      : props.dissociatePercentage === 0
      ? 'text-bluegray-700'
      : 'text-sky-500';
  const comment = props.estimatedPurchasePrice >= 0 ? '増やす' : '減らす';

  return (
    <>
      <div
        className={`relative z-0 rounded-lg border bg-bluegray-60 border-bluegray-300 ${props.className ??
          ''}`}>
        <div
          className="border-b border-r border-bluegray-300 bg-bluegray-60 w-4 h-4 absolute"
          style={{
            transform: 'rotate(-135deg) translateY(80%)',
            right: '6rem',
            top: '0',
            zIndex: 10,
          }}></div>
        <div className="z-20 rounded-lg absolute right-0 top-0 left-0 bottom-0"></div>
        <div className="z-40 flex flex-col px-4 py-3 rounded-lg">
          <div className="flex flex-row justify-between items-center">
            <div className="font-normal text-sm">目標の差：</div>
            <div className="text-bluegray-700 flex flex-row items-baseline">
              <div className={`text-lg ${percentageColor}`}>
                {addSignCommaFormat(props.dissociatePercentage, {
                  numberOfDecimals: 0,
                })}
              </div>
              <div className="text-xs ml-1">%</div>
            </div>
          </div>
          <div className="mt-1 flex flex-row justify-between items-center">
            <div className="font-normal text-sm">購入金額の目安：</div>
            <div className="text-bluegray-700 flex flex-row items-baseline">
              <div className="font-bold text-lg">
                {formatNumber(Math.abs(props.estimatedPurchasePrice), {
                  numberOfDecimal: 0,
                })}
              </div>
              <div className="ml-1 font-normal text-xs">円分{comment}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
